/* import __COLOCATED_TEMPLATE__ from './suggestion-sample-api-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type PulseAccordionSection } from 'glint/pulse';

export interface SampleApiDoc {
  requestMethod: string;
  requestUrl: string;
  requestBody: Record<string, any>;
  responseBody: Record<string, any>;
}

interface Signature {
  Args: {
    section: PulseAccordionSection;
    sectionId: string;
    sampleApiDoc: SampleApiDoc;
  };
}

export default class SuggestionSampleApiItem extends Component<Signature> {
  @service declare intl: IntlService;

  get formattedApiDocumentationDescription() {
    let text = this.intl.t(
      'automation.analyze.task-suggestions.api-docs-side-drawer.api_documentation.description',
    );
    return sanitizeHtml(text);
  }

  get formattedActionParams() {
    if (!this.hasActionParams) {
      return '{}';
    }
    return JSON.stringify(this.args.sampleApiDoc.requestBody, null, 2);
  }

  get hasActionParams() {
    return Object.keys(this.args.sampleApiDoc.requestBody).length > 0;
  }

  get hasMockResponse() {
    return Object.keys(this.args.sampleApiDoc.responseBody).length > 0;
  }

  get formattedMockResponse() {
    if (!this.hasMockResponse) {
      return '{}';
    }
    return JSON.stringify(this.args.sampleApiDoc.responseBody, null, 2);
  }

  /*TODO: missing hover and copy functionality*/
  get isHoveringSampleRequest() {
    /*TODO: implement me*/
    return false;
  }

  get isHoveringCopyButton() {
    /*TODO: implement me*/
    return false;
  }

  get isHoveringSampleResponse() {
    /*TODO: implement me*/
    return false;
  }

  get isHoveringCopyResponseButton() {
    /*TODO: implement me*/
    return false;
  }

  onHoverSampleRequest = () => {
    /*TODO: implement me*/
  };

  onLeaveSampleRequest = () => {
    /*TODO: implement me*/
  };

  onCopyActionParams = () => {
    /*TODO: implement me*/
  };

  onCopyButtonHover = () => {
    /*TODO: implement me*/
  };

  onCopyButtonLeave = () => {
    /*TODO: implement me*/
  };

  onHoverSampleResponse = () => {
    /*TODO: implement me*/
  };

  onLeaveSampleResponse = () => {
    /*TODO: implement me*/
  };

  onCopyMockResponse = () => {
    /*TODO: implement me*/
  };

  onCopyResponseButtonHover = () => {
    /*TODO: implement me*/
  };

  onCopyResponseButtonLeave = () => {
    /*TODO: implement me*/
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionAccordionItems::SuggestionSampleApiItem': typeof SuggestionSampleApiItem;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-accordion-items/suggestion-sample-api-item': typeof SuggestionSampleApiItem;
  }
}
